import moment from "moment";
// const { NODE_ENV } = process.env;

export const imageLoader = ({ src, width, quality }) => {
    return `https://thumbs.gfycat.com/DesertedDazzlingBudgie-size_restricted.gif`
}
const ISSERVER = typeof window === "undefined";


export const deleteUser = () => {
    if (!ISSERVER) {
        localStorage.removeItem("user");
    }
};

export const addToStorage = function (key, data) {
    data = JSON.stringify(data)
    if (!ISSERVER) {
        localStorage.setItem(key, data)
    }
}

export const getFromStorage = function (key) {
    if (!ISSERVER) {
        return JSON.parse(localStorage.getItem(key))
    }
    return ''
}

export const removeFromStorage = function (key) {
    if (!ISSERVER) {
        localStorage.removeItem(key)
    }
}

export const LocalStorageKeys = Object.freeze({
    User: "user",
    Token: "token"
})

export const ImageUrl = (image) => {
    let {PUBLIC_URL} = process.env
    return `${PUBLIC_URL}/images1/${image}`
}
export const extractDate = (date) => {
    const dateObj = new Date(date);
    const options = {
      timeZone: "UTC",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const formattedDate = dateObj.toLocaleDateString("en-US", options);
    return formattedDate;
  };
// export const extractTime = (date) => {
//     const dateObj = new Date(date);
//     const timeString = dateObj.toLocaleTimeString([], {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//       timeZone: "UTC",
//     });
//     return timeString;
//   };
export const extractTime = (date) => {
  const dateObj = new Date(date);
  let timeString;
  // if(NODE_ENV === "production"){
  //   timeString = moment(dateObj).subtract(5, "hours").format("hh:mm A");
  // }
  // else{
    timeString = moment(dateObj).format("hh:mm A");
  // }
  return timeString;
};
  export const calculateReviewsAverage = (reviews) => {
      if (!reviews || reviews?.length === 0) {
        return 0;
      }
      const totalRatings = reviews.reduce(
        (sum, review) => sum + review.rating,
        0
      );
      const averageRating = totalRatings / reviews?.length;
      return averageRating;
    };
  